var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStudentDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 17.2641V19.5431C2.18737 19.3211 3.4347 19.2089 4.61843 19.2089C6.61972 19.2089 8.52126 19.5306 10.2807 20.1665V17.9134C7.82673 16.7936 4.7161 16.5763 0.904297 17.2641Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6881 9.87998C10.6989 9.87998 10.7097 9.87874 10.7205 9.87874C10.7309 9.87874 10.7404 9.87998 10.7508 9.8804C12.9558 9.86377 14.7447 8.06656 14.7447 5.85745C14.7447 3.63836 12.9396 1.83325 10.7205 1.83325C8.5014 1.83325 6.69629 3.63836 6.69629 5.85745C6.69629 8.06531 8.48394 9.86253 10.6881 9.87998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1611 17.9134V20.1665C13.9609 19.1549 17.0844 18.9462 20.5375 19.5431V17.2641C16.7257 16.5763 13.6146 16.7936 11.1611 17.9134Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1794 16.0652C17.7937 14.9467 17.1557 13.9217 16.3069 13.073C14.8227 11.5888 12.8505 10.7691 10.7515 10.7612C10.7411 10.7612 10.7316 10.7629 10.7212 10.7629C10.7104 10.7629 10.6996 10.7612 10.6888 10.7612C7.32129 10.7749 4.35821 12.9221 3.26758 16.0643C6.18203 15.8266 8.6613 16.1903 10.7212 17.1508C12.7819 16.1899 15.2629 15.8266 18.1794 16.0652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudentDashboard);
export default __webpack_public_path__ + "static/media/ic-student-dashboard.cb73aecba72874d2f145f7023acb900e.svg";
export { ForwardRef as ReactComponent };